import { TableBody as AriaTableBody, composeRenderProps, type TableBodyProps } from 'react-aria-components';
import clsx from 'clsx';

import styles from './TableBody.module.css';

type Props<T extends object> = TableBodyProps<T>;

export function TableBody<T extends object>({ children, ...props }: Props<T>) {
  return (
    <AriaTableBody
      {...props}
      className={composeRenderProps(props.className, (className) => clsx(className, styles.TableBody))}
    >
      {children}
    </AriaTableBody>
  );
}
